import { useEffect, useRef, type ReactNode } from "react";
import hljs from "highlight.js/lib/core";
import bash from "highlight.js/lib/languages/bash";
import json from "highlight.js/lib/languages/json";
import plaintext from "highlight.js/lib/languages/plaintext";
import sql from "highlight.js/lib/languages/sql";

// Register only the languages used by the docs pages (plus bash/plaintext
// for the runbook pages) instead of importing the full highlight.js bundle.
hljs.registerLanguage("bash", bash);
hljs.registerLanguage("json", json);
hljs.registerLanguage("plaintext", plaintext);
hljs.registerLanguage("sql", sql);

/**
 * MDX `pre` renderer: highlights code blocks client-side with highlight.js.
 * The language hint comes from the `language-*` class MDX attaches to the
 * inner <code> element (e.g. language-ts, language-bash). Blocks without a
 * language hint fall back to auto-detection over the registered languages.
 */
export function CodeBlock({ children }: { readonly children?: ReactNode }) {
  const preRef = useRef<HTMLPreElement>(null);

  useEffect(() => {
    const pre = preRef.current;
    if (!pre) return;
    for (const code of pre.querySelectorAll("code")) {
      hljs.highlightElement(code);
    }
  });

  return <pre ref={preRef}>{children}</pre>;
}
